import {
  createSelectionColumn,
  ExplorerStyledDisplayGrid,
  GraphQLError,
  GridSortProps,
  reportGraphQLErrors,
  SelectionProviderChildProps,
  TypedColumn,
  UsualDisplayGridProps
} from '@tableau/data-catalog-shared';
import * as React from 'react';

import { columns } from '../sharedDisplayGrid/TablesDisplayGrid';
import { TablesValidSortFields } from '../sorting/sortProviders/TablesGridSortProvider';
import { TablesDisplayGridRowData } from '../table/types/TablesDisplayGridRowData';

export type DatabaseTablesDisplayGridProps =
  UsualDisplayGridProps<TablesDisplayGridRowData, GraphQLError> &
  GridSortProps<TablesValidSortFields> &
  SelectionProviderChildProps;

export function DatabaseTablesDisplayGrid(props: DatabaseTablesDisplayGridProps): JSX.Element {
  const cols: TypedColumn<TablesDisplayGridRowData, TablesValidSortFields>[] = [
    createSelectionColumn(),
    ...columns.map(columnFactory => columnFactory(props)).filter(column => column.name !== 'database')
  ]

  return (
    <ExplorerStyledDisplayGrid
      columns={cols}
      rowStore={props.rowStore}
      selectedKeys={props.selectedKeys}
      updateSelectionForKey={props.updateSelectionForKey}
      rowCount={props.rowCount}
      renderErrors={reportGraphQLErrors}
      orderBy={props.orderBy}
      updateSortOrder={props.updateSortOrder}
    />
  );
}
